import React from 'react'

import PropTypes from 'prop-types'
import {Box, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {InfoIcon} from '../icons'
import InfoPopover from '../popovers/info-popover'

const BenefitCard = ({icon, children, infoPopoverTitle, infoPopoverDescription}) => {
    const styles = useMultiStyleConfig('BenefitCard')

    return (
        <Box {...styles.card}>
            {icon}
            <Text {...styles.text}>{children}</Text>
            <Box {...styles.infoPopBox}>
                <InfoPopover
                    variant="left-center"
                    trigger={<InfoIcon {...styles.infoIcon} aria-label="More Info" />}
                    openTooltipOn="hover"
                    title={infoPopoverTitle}
                    description={infoPopoverDescription}
                />
            </Box>
        </Box>
    )
}

BenefitCard.propTypes = {
    icon: PropTypes.node,
    children: PropTypes.node,
    infoPopoverTitle: PropTypes.string,
    infoPopoverDescription: PropTypes.string,
}

export default BenefitCard
